import Immutable from 'immutable';
import createReducers from '../utils/createreducer';
import {
    ADD_GLOBAL_ERROR, REMOVE_GLOBAL_ERROR, REMOVE_ALL_GLOBAL_ERRORS
} from '../constants/actionconstants';
import initialStoreState from '../store/initialstorestate';

const initialState = initialStoreState.globalError;

export default createReducers(initialState, {
    [ADD_GLOBAL_ERROR] : (state, payload) => {
        return Object.assign({}, state, {
            errors: state.errors.push(payload)
        });
    },
    [REMOVE_GLOBAL_ERROR] : (state, payload) => {
        const errorIdToRemove = payload.errorId;
        return Object.assign({}, state, {
            errors: state.errors.filter(e => e.errorId != errorIdToRemove) // remove the error with errorId = payload.errorId from the list
        });
    },
    [REMOVE_ALL_GLOBAL_ERRORS] : (state, payload) => {
        return Object.assign({}, state, {
            errors: new Immutable.List()
        });
    }
});



// WEBPACK FOOTER //
// ./src/client/src/reducers/globalerror.js